import type { PriceValue } from '@elfsight/configurator-contracts';

export const priceDefaultSettings: PriceValue = {
  pricingModel: 'fixed',
  price: 1000,
  customPrice: 'Custom',
  currency: 'USD',
  period: 'month',
  minPrice: 1000,
  maxPrice: 1200,
  unit: 'item'
};
